import { getItem } from '../../services/common/utils';
import { SELECTED_LANG } from '../../services/common/Constants';
import { DOMAIN } from './endpoints';
import { isDevEnv } from './CommonUtils';

export const redirecturl = async (
  url,
  navigate,
  show,
  toggleModal,
  urlData, 
  shouldReplace = false,
  isViewPacks = false
) => {

  var _lang = await getItem(SELECTED_LANG);
// console.log(url, "urlll")
// console.log('urlData', urlData);
  try {
    switch (url.toLowerCase()) {
      case '/pay' :
      case 'payment': 
      case 'recharge': {
        navigate('/recharge', { state: urlData });
        break;
      }
      case 'pay':{
        navigate('/recharge');
        break;
      }
      case '/recharge': {
        navigate('/paybill');
        break;
      }
      case '/editmanagelines': {
        navigate('/edit-manage-lines');
        break;
      }
      case '/addonshome': 
      case 'addonshome':{
        navigate('/addonshome');
        break;
      }
      case '/homepage': {
        navigate('/home/index');
        break;
      }
      case '/payviewbill': {
        // navigate('/viewbill');
        navigate('/your-bill');
        break;
      }
      case '/payviavoucher': {
        navigate('/payviavoucher');
        break;
      }
      case '/ooredoosurprise': {
        navigate('/ooredoo-surprise');
        break;
      }
      case '/shophome': {
        if (_lang === 'en') {
          window.open('https://shop.ooredoo.com.kw/EN/', '_blank');
        } else {
          window.open('https://shop.ooredoo.com.kw/AR/', '_blank');
        }
        break;
      }
      case 'verifycivilid': {
        navigate('/verify-account?headerText=va', { state: urlData });
        break;
      }
      case 'passportmulticountry': {
        navigate('/passportmulticountry');
        break;
      }
      case 'mycountryhome': {
        navigate('/mycountryhome');
        break;
      }
      case 'ooredoopassporthome': {
        navigate('/passportmulticountry');
        break;
      }
      case 'earnpointspartnerhome': {
        navigate('/earn-points');
        break;
      }
      case 'nojoombuypoints': {
        navigate('/nojoom-buypoints');
        break;
      }
      case 'nojoomtransferfriends': {
        navigate('/nojoomtransferfriends', { state: urlData });
        break;
      }
      case 'nojoomtransferpoints': {
        navigate('/transfertopartner', { state: urlData });
        break;
      }
      case 'nojoomdonatepoints': {
        navigate('/nojoomdonate', { state: urlData });
        break;
      }
      case 'nojoomdonate': {
        navigate('/nojoomdonate', { state: urlData });
        break;
      }
      case 'transfertopartner': {
        navigate('/transfertopartner', { state: urlData });
        break;
      }
      case '/transfer-balance': {
        navigate('/transfer-balance', { state: urlData });
        break;
      }
      case '/xpressprofit':{
        navigate('/xpress-profit');
        break;
      }
      case '/transfercredit':{
        navigate('/transfer-credit');
        break;
      }
      case '/requestcredit':{
        navigate('/requestcredit');
        break;
      }
      case 'loadbalancehome':{
        navigate('/load-balance');
        break;
      }
      case 'smartpaymanage':{
        navigate('/smart-pay-manage', {replace: shouldReplace});
        break;
      }
      case 'smartpayenroll':{
        navigate('/smart-pay-cards', {replace: shouldReplace});
        break;
      }
      case 'smartpayeditnumbers':{
        navigate('/smart-pay-edit-numbers', {replace: shouldReplace});
        break;
      }
      case 'smartpayeditcard':{
        navigate('/smart-pay-edit-cards', {replace: shouldReplace});
        break;
      }
      case '/paytransfercredits': {
        navigate('/transfer-credit');
        break;
      }
      case 'specialdeals':{
        navigate('/special-deals');
        break;
      }
      case 'roamingviewall': {
        navigate('/passportmulticountry');
        break;
      }
      case 'cvmproductdetail': {
        navigate(`/cvm-offer-detail/${urlData.offercode}`);
        break;
      }
      case '/paytransfercredits': {
        navigate('/transfer-credit');
        break;
      }
      case 'addonsviewall':{
        navigate('/addonshome');
        break;
      }
      case 'earnpointspartnerhome':{
        navigate('/earn-points')
        break;
      }
      case "nojoombuypoints":{
        navigate('/nojoom-buypoints')
        break;
      }
      case "roaminghome":{
        navigate('/roaminghome')
        break;
      }
      case "bundlesviewall":{
        navigate('/bundles');
        break;
      }
      case "roamingrates":{
        if(isViewPacks){
          navigate('/roaming-rates', {state: {isViewPacks: true}});
        }else{
          navigate('/roaming-rates');
        }
        break;
      }
      case "nojoom":{
        navigate('/nojoom');
        break;
      }
      case "passportcountries":{
        navigate('/passport-countries-list');
        break;
      }
      case "internettransfer":{
        navigate('/internet-transfer');
        break;
      }
      //sprint-16
      case "more_myaccount":{
        navigate('/my-account');
        break;
      }
      case "more_mypayments":{
        navigate('/my-payments');
        break;
      }
      case "more_termsandconditions":{
        navigate('/terms-and-conditions',{ state: urlData } );
        break;
      }
      case 'transactionhistory':{
        navigate('/transaction-history');
        break;
      }
      case 'mycards':{
        navigate('/payment-method');
        break;
      }

      case "personalinfo":{
        navigate('/personal-info');
        break;
      }
      case "pwdmanagement": {
        navigate('/password-management');
        break;
      }

      case 'billbalance': {
        navigate('/support-assistant?level=3&id=1013&headerText=bill_balance');
        break;
      }
      case 'paymentrechargeproblems': {
        navigate('/support-assistant?level=3&id=1014&headerText=payment_recharge');
        break;
      }
      case 'supporthelparticallevelone': {
        navigate('/support-assistant?level=2&id=1003&headerText=help_articles');
        break;
      }
      case 'supportneedhelplevelone': {
        navigate('/support-assistant?level=2&id=1002&headerText=need_help');
        break;
      }
      case 'supportpayments': {
        navigate('/payments');
        break;
      }
      case 'trackcomplaints': {
        navigate('/track-complaints');
        break;
      }
      case 'passwordmanagement': {
        navigate('/password-management', { state: urlData });
        break;
      }
      case 'editprofile': {
        navigate('/personal-info');
        break;
      }
      case 'viewbill': {
        navigate('/your-bill');
        break;
      }
      case 'supportpaymenttransactions': {
        navigate('/transaction-history');
        break;
      }
      // case url: {
      //   navigate('/' + url);
      //   break;
      // }
      default: {
        toggleModal();
        break;
      }
    }
  } catch (error) {
    // console.log(error);
  }
};

export const getCompleteRedirectUrl = (url) => {
  let appUrl= '/';

  switch (url.toLowerCase()) {
    case '/pay' :
    case 'payment': 
    case 'recharge': {
      // navigate('/recharge', { state: urlData });
      appUrl = '/recharge';
      break;
    }
    case 'pay': {
      appUrl = '/recharge';
      break;
    }
    case '/recharge': {
      // navigate('/paybill');
      appUrl = '/paybill';
      break;
    }
    case '/editmanagelines': {
      // navigate('/edit-manage-lines');
      appUrl = "/edit-manage-lines";
      break;
    }
    case '/addonshome': {
      appUrl = "/addonshome";
      // navigate('/addonshome');
      break;
    }
    case '/homepage': {
      // navigate('/home/index');
      appUrl = '/home/index'
      break;
    }
    case '/payviewbill': {
      // navigate('/viewbill');
      // appUrl = '/viewbill'
      appUrl = '/your-bill'
      break;
    }
    case '/payviavoucher': {
      // navigate('/payviavoucher');
      appUrl = '/payviavoucher'
      break;
    }
    case '/ooredoosurprise': {
      // navigate('/ooredoo-surprise');
      appUrl = '/ooredoo-surprise'
      break;
    }
    // case '/shophome': {
    //   if (_lang === 'en') {
    //     window.open('https://shop.ooredoo.com.kw/EN/', '_blank');
    //   } else {
    //     window.open('https://shop.ooredoo.com.kw/AR/', '_blank');
    //   }
    //   break;
    // }
    case 'verifycivilid': {
      // navigate('/verify-account?headerText=va', { state: urlData });
      appUrl = '/verify-account?headerText=va';
      break;
    }
    case 'passportmulticountry': {
      // navigate('/passportmulticountry');
      appUrl = '/passportmulticountry';
      break;
    }
    case 'mycountryhome': {
      // navigate('/mycountryhome');
      appUrl = '/mycountryhome';
      break;
    }
    case 'ooredoopassporthome': {
      // navigate('/passportmulticountry');
      appUrl = '/passportmulticountry';
      break;
    }
    case 'earnpointspartnerhome': {
      // navigate('/earn-points');
      appUrl = '/earn-points'
      break;
    }
    case 'nojoombuypoints': {
      // navigate('/nojoom-buypoints');
      appUrl = '/nojoom-buypoints'
      break;
    }
    case 'nojoomtransferfriends': {
      // navigate('/nojoomtransferfriends', { state: urlData });
      appUrl = '/nojoomtransferfriends'
      break;
    }
    case 'nojoomtransferpoints': {
      // navigate('/transfertopartner', { state: urlData });
      appUrl = '/transfertopartner';
      break;
    }
    case 'nojoomdonatepoints': {
      // navigate('/nojoomdonate', { state: urlData });
      appUrl = '/nojoomdonate'
      break;
    }
    case 'nojoomdonate': {
      // navigate('/nojoomdonate', { state: urlData });
      appUrl = '/nojoomdonate'
      break;
    }
    case 'transfertopartner': {
      // navigate('/transfertopartner', { state: urlData });
      appUrl = '/transfertopartner';
      break;
    }
    case '/transfer-balance': {
      // navigate('/transfer-balance', { state: urlData });
      appUrl = '/transfer-balance';
      break;
    }
    case '/xpressprofit':{
      // navigate('/xpress-profit');
      appUrl = '/xpress-profit';
      break;
    }
    case '/transfercredit':{
      // navigate('/transfer-credit');
      appUrl = '/transfer-credit';
      break;
    }
    case '/requestcredit':{
      // navigate('/requestcredit');
      appUrl = '/requestcredit';
      break;
    }
    case 'loadbalancehome':{
      // navigate('/load-balance');
      appUrl = '/load-balance';
      break;
    }
    case 'smartpaymanage':{
      // navigate('/smart-pay-manage', {replace: shouldReplace});
      appUrl = '/smart-pay-manage';
      break;
    }
    case 'smartpayenroll':{
      // navigate('/smart-pay-cards', {replace: shouldReplace});
      appUrl = '/smart-pay-cards';
      break;
    }
    case 'smartpayeditnumbers':{
      // navigate('/smart-pay-edit-numbers', {replace: shouldReplace});
      appUrl = '/smart-pay-edit-numbers';
      break;
    }
    case 'smartpayeditcard':{
      // navigate('/smart-pay-edit-cards', {replace: shouldReplace});
      appUrl = '/smart-pay-edit-cards';
      break;
    }
    case '/paytransfercredits': {
      // navigate('/transfer-credit');
      appUrl = '/transfer-credit';
      break;
    }
    case 'specialdeals':{
      // navigate('/special-deals');
      appUrl = '/special-deals'
      break;
    }
    case 'roamingviewall': {
      // navigate('/passportmulticountry');
      appUrl = '/passportmulticountry'
      break;
    }
    case 'cvmproductdetail': {
      // navigate(`/cvm-offer-detail/${urlData.offercode}`);
      appUrl = '/cvm-offer-detail';
      break;
    }
    case 'addonsviewall':{
      // navigate('/addonshome');
      appUrl = '/addonshome'
      break;
    }
    case 'bundlesviewall': {
      // navigate('/bundles');
     appUrl = '/bundles';
     break;
    }
    default: {
      appUrl = '/';
      break;
    }
  }

  // return appUrl;
  const requiredDomain = isDevEnv() ? 'http://localhost:3000' : DOMAIN;
  return `${requiredDomain}${process.env.PUBLIC_URL}/#${appUrl}`;
}
